;(function(w){
	function Main(routes, capitulos){
		var self = this;
		this.main = document.getElementById('main');

		var menu = new Menu();
		var sections_holder = new SectionsHolder();
		sections_holder.resize();
			
		var arr_capitulos = [];

		capitulos.forEach(function(capitulo){
			arr_capitulos.push(new Capitulo(capitulo));
		})

		
		Main.lightbox_contenido = new LightboxContenido();
		Main.lightbox_imagen = new LightboxImagen();
		Main.lightbox_creditos = new LightboxCreditos();

		Main.es_mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);

		var footer = new Footer();

		
		var wow = new WOW({
				boxClass:     'wow',     
				animateClass: 'wowAnim',
				offset:       0,       
				mobile:       true,      
				live:         false 
		    });

		wow.init();

		
		var scroll_btn = $('.scroll_btn')[0];// el principal



		$(self.main).addClass('active');
			
		
		
		var current_index;
		var route_key;

		var hammer = new Hammer(sections_holder.main);
		hammer.get('swipe').set({direction: Hammer.DIRECTION_ALL})
		hammer.on("swipe", onSwipe);


		this.main.addEventListener('wheel', onWheel);
		window.addEventListener('hashchange', onHashChange);
		window.addEventListener('resize', onResize);
		$(this.main).bind('SECTIONS_HOLDER_ANIMATION_START', onSectionsHolderAnimationStart);
		$(this.main).bind('SECTIONS_HOLDER_ANIMATION_END', onSectionsHolderAnimationEnd);
		$(document).bind('keydown', onKeyDown);
		$('.btn-scroll > .scroll').bind('click', onClickScrollBtn);
		$('.creditos_btn').bind('click', onClickCreditosBtn);

		onHashChange();

		function onWheel(e){
			e.preventDefault();

			if(e.deltaY > 0){ //Sube
				goDirection(1);
			}else{//Baja
				goDirection(-1);
			}
			
		}

		function onSwipe(e){
			e.preventDefault();
			
			switch(e.direction){
				case 8: goDirection(1);
						break;
				case 16: goDirection(-1);
						 break;
			}
		}

		function goDirection(direction){
			if(!sections_holder.estaAnimando() && !Main.lightbox_contenido.estaAbierto()){
				
				var new_index = current_index;

				if(direction > 0){
					if(current_index < routes.length - 1){
						new_index = current_index + 1;
					}
				}else{
					if(current_index > 0){
						new_index = current_index - 1;
					}
				}

				window.location.hash = '/'+routes[new_index].url;
			}	
		}

		function onKeyDown(e){
			switch(e.keyCode){
				case 38: goDirection(1);
						 break;
				case 40: goDirection(-1);
						 break;			 	
			}
		}


		function onHashChange(e){
					
			current_index = getRouteIndexByUrl(window.location.hash.substr(2));

			route_key = routes[current_index].key;

			menu.set(route_key);
			sections_holder.set(route_key);
		}

		function getRouteIndexByUrl(url){
			var result = 0;
			
			for(var i=0; i < routes.length; i++){
				if(routes[i].url == url){
					result = i;
					break;
				}
			}
			
			return result;
		}

		function onResize(e){
			sections_holder.resize();
		}

		function onSectionsHolderAnimationStart(e){
			footer.ocultar();
			$(scroll_btn).removeClass('active');
		}

		function onSectionsHolderAnimationEnd(e){
			if(current_index != 0){
				footer.mostrar();	
				if(current_index != routes.length - 1){
					$(scroll_btn).addClass('active');
				}
			}else{
				footer.mostrar(true);
			}
			
		}

		function onClickScrollBtn(e){
			e.preventDefault();

			goDirection(1);
		}

		function onClickCreditosBtn(e){
			e.preventDefault();

			Main.lightbox_creditos.mostrar();
		}
	

	}
	
	w.Main = Main;
})(window)